import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import OkCSSLoader from "shared/components/OkCSSLoader";
import Str from "shared/components/Str";

import {
	POPOVER_WIDTH,
	POPOVER_HEIGHT,
} from "shared/components/ProfileQuickview/util/constants";

import "./ProfileQuickview.scss";

const STATES = {
	LOADING: "LOADING",
	ERROR: "ERROR",
	READY: "READY",
};

const ProfileQuickview = ({
	show,
	position,
	userData,
	error,
}) => {
	let state = STATES.LOADING;

	if (error) {
		state = STATES.ERROR;
	} else if (userData) {
		state = STATES.READY;
	}

	const userImage = userData?.thumbs?.[0]?.["82x82"];
	const displayName = userData?.userinfo?.displayname;
	const age = userData?.userinfo?.age;
	const location = userData?.userinfo?.location;
	const matchPercent = userData?.percentages?.match;
	const detailTags = userData?.["detail_tags"] || [];

	return (
		<div
			className={classnames("quickview", {
				show,
				"quickview--is-flipped": position.isFlipped,
				"quickview--is-loading": state === STATES.LOADING,
				"quickview--is-error": state === STATES.ERROR,
			})}
			style={{
				top: `${position.top || 0}px`,
				left: `${position.left || 0}px`,
				width: `${POPOVER_WIDTH}px`,
				height: `${POPOVER_HEIGHT}px`,
			}}
		>
			<div className="quickview-inner">
				{state === STATES.READY && (
					<>
						<div className="quickview-top">
							<div className="quickview-top-photo">
								<img className="active" src={userImage} alt={`${displayName}’s profile overview`} />
							</div>

							<span className="quickview-top-username">
								{displayName}
							</span>

							<div className="quickview-top-demo">
								<div className="quickview-top-demo-age">
									{age}
								</div>
								<div className="quickview-top-demo-location">
									{location}
								</div>
							</div>

							{matchPercent && (
								<div className="quickview-top-percentage">
									{matchPercent}
									<span className="quickview-top-percentage-sign">
										%
									</span>
								</div>
							)}
						</div>

						<div className="quickview-bottom">
							{!!detailTags.length && (
								<div className="quickview-bottom-tags">
									{detailTags.map((tag, i) => (
										<span
											key={tag}
											className="quickview-bottom-tags-tag"
										>
											{!!i && <span>,&nbsp;</span>}
											{tag}
										</span>
									))}
								</div>
							)}
							{!detailTags.length && (
								<Str className="quickview-bottom-empty">
									Not enough info. Drats!
								</Str>
							)}
						</div>
					</>
				)}
				{state === STATES.ERROR && <div className="quickview-error">{error}</div>}
				{state === STATES.LOADING && <OkCSSLoader className="quickview-loader" show />}
			</div>
			<div
				className="quickview-arrow"
				style={{
					marginLeft: `${position.arrowMarginLeft || 0}px`,
				}}
			/>
		</div>
	);
};

ProfileQuickview.propTypes = {
	show: PropTypes.bool.isRequired,
	position: PropTypes.shape({
		top: PropTypes.number,
		left: PropTypes.number,
		arrowMarginLeft: PropTypes.number,
		isFlipped: PropTypes.bool,
	}),
	userData: PropTypes.object,
	error: PropTypes.string,
};

ProfileQuickview.defaultProps = {
	position: {},
	userData: null,
	error: null,
};

export default ProfileQuickview;



// WEBPACK FOOTER //
// ./src/shared/components/ProfileQuickview/ProfileQuickview.jsx